import { addLocaleData } from 'react-intl';
import nl from 'react-intl/locale-data/nl';
import navLocaleData from '@99designs/common/apps/global-nav/locale-data/nl';
import { setTranslations as setNavTranslations } from '@99designs/common/apps/global-nav/locale-data';

setNavTranslations(navLocaleData);
addLocaleData(nl);



// WEBPACK FOOTER //
// ./src/js/locale-data/nl.js